import request from "axios";

// eslint-disable-next-line
export const getCostCentreForApprovedTimesheet = async (
  accessToken,
  timesheetRef
) =>
  request
    .get(
      `${process.env.REACT_APP_PROFILE_API_URL}/clientDashboard/timesheets/costCentreCode/${timesheetRef}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }
      }
    )
    .then(({ data }) => data)
    .catch(() => {});
